<template>
  <div id="domains" class="container">
    <v-dialog v-model="deleteDomain.modal" width="400">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title>Deleting Domain</v-card-title>
        <v-card-text
          >Are you sure you want to delete {{ deleteDomain.item.domain }}? All
          users that have this domain assigned will be reset back to
          {{ $store.state.site.hostname }}, and the zone will be removed from
          Cloudflare.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="primary"
            text
            @click="deleteDomain.modal = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="rounded-xl"
            :loading="deleteDomain.loading"
            color="red"
            text
            @click="doDeleteDomain()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="defaultDomain.modal" width="700">
      <v-card
        v-if="
          defaultDomain.item.restricted === 'disabled' ||
          (defaultDomain.item.restricted === 'premium' &&
            $store.state.user.plan.id > 1) ||
          (defaultDomain.item.restricted === 'user' &&
            JSON.parse(defaultDomain.item.customUserEligibility).includes(
              $store.state.user.id
            )) ||
          defaultDomain.item.userId === $store.state.user.id
        "
        class="rounded-xl"
        elevation="7"
      >
        <v-card-title> Default Domain Options</v-card-title>
        <v-card-text>
          You are setting {{ defaultDomain.item.domain }} as your default
          domain.
        </v-card-text>
        <v-card-text
          v-if="defaultDomain.item.subdomains && defaultDomain.item.subdomains"
        >
          {{ $store.state.site.name }} now supports subdomains, subdomains allow
          you to customize the start of the domain of your choosing. You may set
          one here, if you don't want to set one, just press the "Set as
          Default" button and it will apply the domain with no subdomain.
        </v-card-text>
        <v-card-text
          v-if="defaultDomain.subdomainEnabled && defaultDomain.subdomain"
        >
          Preview: https://{{ defaultDomain.subdomain }}.{{
            defaultDomain.item.domain
          }}
        </v-card-text>
        <v-card-text v-if="!defaultDomain.subdomainEnabled">
          Preview: https://{{ defaultDomain.item.domain }}
        </v-card-text>
        <v-card-text
          v-if="defaultDomain.subdomainEnabled && !defaultDomain.subdomain"
        >
          Example: https://{{ $store.state.user.username.toLowerCase() }}.{{
            defaultDomain.item.domain
          }}
        </v-card-text>
        <v-card-text v-if="!defaultDomain.item.subdomains">
          This domain does not support any custom options.
        </v-card-text>
        <v-container
          v-if="
            defaultDomain.item.subdomains && defaultDomain.item.subdomainsCreate
          "
        >
          <v-checkbox
            v-model="defaultDomain.subdomainEnabled"
            label="Use subdomain"
          ></v-checkbox>
          <v-row v-if="defaultDomain.subdomainEnabled">
            <v-col cols="12">
              <v-text-field
                class="rounded-xl"
                v-model="defaultDomain.subdomain"
                label="Subdomain Name"
                placeholder="Example: username"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container
          v-if="
            defaultDomain.item.subdomains &&
            !defaultDomain.item.subdomainsCreate
          "
        >
          <v-checkbox
            v-model="defaultDomain.subdomainEnabled"
            label="Use subdomain"
          ></v-checkbox>
          <v-row v-if="defaultDomain.subdomainEnabled">
            <v-col cols="12">
              <v-select
                v-model="defaultDomain.subdomain"
                :items="defaultDomain.subdomains"
                item-text="name"
                item-value="name"
                label="Subdomain"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="red"
            text
            @click="defaultDomain.modal = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="rounded-xl"
            :loading="defaultDomain.loading"
            color="primary"
            text
            @click="setDefaultAction()"
          >
            Set as Default
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card
        v-if="
          defaultDomain.item.restricted === 'premium' &&
          $store.state.user.plan.id === 1 &&
          defaultDomain.item.userId !== $store.state.user.id
        "
        class="rounded-xl"
        elevation="7"
      >
        <v-card-title> Eligibility Requirement for this domain.</v-card-title>
        <v-card-text
          >This domain requires you have an active Premium or Advanced
          subscription to {{ $store.state.site.name }}.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="primary"
            text
            @click="defaultDomain.modal = false"
          >
            Got it
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card
        v-if="
          defaultDomain.item.restricted === 'user' &&
          !defaultDomain.item.customUserEligibility.includes(
            $store.state.user.id
          ) &&
          defaultDomain.item.userId !== $store.state.user.id
        "
        class="rounded-xl"
        elevation="7"
      >
        <v-card-title> Eligibility Requirement for this domain.</v-card-title>
        <v-card-text
          >This domain requires you to be added manually by the domain owner to
          use this domain.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="primary"
            text
            @click="defaultDomain.modal = false"
          >
            Got it
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card v-if="loading" class="rounded-xl" elevation="7">
      <v-container class="text-center">
        <p class="text-lg-h4">Loading...</p>
      </v-container>
    </v-card>
    <div v-if="!loading">
      <v-data-table
        v-if="donated.domains.length"
        :headers="donated.headers"
        :items="donated.domains"
        class="rounded-xl elevation-12"
      >
        <template v-slot:top>
          <v-toolbar
            style="border-top-right-radius: 12px; border-top-left-radius: 12px"
          >
            <v-toolbar-title>Your Domains</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="rounded-xl" @click="$router.push('/domains/donate')">
              Donate more domains!
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.domain="{ item }">
          {{ item.domain }}
        </template>

        <template v-slot:item.activeUsersCount="{ item }">
          {{ item.activeUsersCount }}
        </template>

        <template v-slot:item.options="{ item }">
          <v-card-actions>
            <v-btn
              class="rounded-xl"
              :loading="loading"
              @click="setDefault(item)"
            >
              Set Default
            </v-btn>
            <v-btn
              class="rounded-xl"
              v-if="!item.active"
              :loading="loading"
              @click="recheckNS(item)"
            >
              Recheck NS
            </v-btn>
            <v-btn
              class="rounded-xl"
              @click="$router.push('/domains/manage/' + item.domain)"
            >
              Manage
            </v-btn>
            <v-btn class="rounded-xl" @click="startDeleteDomain(item)">
              Delete</v-btn
            >
          </v-card-actions>
        </template>
      </v-data-table>
      <br />
      <v-data-table
        :headers="all.headers"
        :items="all.domains"
        :items-per-page="all.pager.pageSize"
        :page.sync="all.page"
        :search="all.search"
        class="rounded-xl elevation-12"
        @page-count="all.pager.totalPages = $event"
      >
        <template v-slot:top>
          <v-toolbar
            style="border-top-right-radius: 12px; border-top-left-radius: 12px"
          >
            <v-toolbar-title>All Domains</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="rounded-xl"
              v-if="!donated.domains.length"
              @click="$router.push('/domains/donate')"
            >
              Donate a domain!
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.domain="{ item }">
          {{ item.domain }}
        </template>

        <template v-slot:item.user.username="{ item }">
          <v-tooltip color="hoverCard" top>
            <template v-slot:activator="{ on }">
              <div class="justify-center" v-on="on">
                <v-icon
                  v-if="
                    item.user.plan.internalName !== 'FREE' &&
                    item.user.plan.internalName.indexOf('CSTM_TIER_') >= 0
                  "
                  :color="item.user.plan.color"
                  aria-hidden="false"
                >
                  {{ item.user.plan.icon }}
                </v-icon>
                <v-icon
                  v-if="
                    item.user.administrator &&
                    item.user.plan.internalName.indexOf('CSTM_TIER_')
                  "
                  aria-hidden="false"
                  color="red"
                >
                  mdi-gavel
                </v-icon>
                <v-icon
                  v-if="
                    item.user.plan.internalName !== 'FREE' &&
                    !item.user.administrator &&
                    !item.user.moderator &&
                    item.user.plan.internalName.indexOf('CSTM_TIER_')
                  "
                  :color="item.user.plan.color"
                  aria-hidden="false"
                >
                  {{ item.user.plan.icon }}
                </v-icon>
                <span
                  v-if="
                    item.user.beta &&
                    item.user.plan.internalName === 'FREE' &&
                    !item.user.administrator &&
                    !item.user.moderator &&
                    item.user.plan.internalName.indexOf('CSTM_TIER_')
                  "
                  style="color: #764bc4"
                  >β</span
                >
                <v-icon
                  v-if="
                    item.user.moderator &&
                    !item.user.administrator &&
                    item.user.plan.internalName.indexOf('CSTM_TIER_')
                  "
                  aria-hidden="false"
                  color="green"
                >
                  mdi-shield
                </v-icon>
                <router-link
                  :style="
                    'text-decoration: none; color:' +
                    calculateColor(item.user) +
                    ';'
                  "
                  :to="'/u/' + item.user.username"
                >
                  <template
                    v-if="
                      item.user.moderator ||
                      item.user.administrator ||
                      item.user.plan.internalName.indexOf('CSTM_TIER_') ||
                      item.user.plan.internalName !== 'FREE'
                    "
                    >&nbsp;
                  </template>
                  {{ item.user.username }}
                </router-link>
              </div>
            </template>
            <div class="text-center">
              <p class="text-h6">
                <v-avatar
                  v-if="item.user.avatar"
                  :src="'/i/' + item.user.avatar"
                  align="center"
                  class="text-center"
                  height="40"
                  width="40"
                >
                  <img
                    v-if="item.user.avatar"
                    :src="'/i/' + item.user.avatar"
                  />
                </v-avatar>
                <v-avatar
                  v-if="!item.user.avatar"
                  :src="'/api/v1/userutils/identicon/' + item.user.username"
                  align="center"
                  class="text-center justify-center"
                  justify="center"
                  size="40"
                >
                  <img
                    v-if="!item.user.avatar"
                    :src="'/api/v1/userutils/identicon/' + item.user.username"
                  /> </v-avatar
                >&nbsp;{{ item.user.username }} (<span
                  style="
                    font-weight: 500;
                    background: -webkit-linear-gradient(#0179f3, #0190ea);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  "
                  >{{ item.user.id }}</span
                >)
              </p>
              <v-chip
                v-if="
                  item.user.plan.internalName !== 'FREE' &&
                  item.user.plan.internalName.indexOf('CSTM_TIER_') >= 0
                "
                :color="item.user.plan.color"
                class="ma-1"
                text-color="white"
              >
                <v-icon> {{ item.user.plan.icon }}</v-icon
                >&nbsp;
                {{ item.user.plan.name }}
              </v-chip>
              <v-chip
                v-if="item.user.administrator"
                class="ma-1"
                color="red"
                text-color="white"
              >
                <v-icon> mdi-gavel</v-icon>&nbsp;Administrator
              </v-chip>
              <v-chip
                v-if="item.user.moderator"
                class="ma-1"
                color="green"
                text-color="white"
              >
                <v-icon> mdi-shield</v-icon>&nbsp;Moderator
              </v-chip>
              <v-chip
                v-if="
                  item.user.plan.internalName !== 'FREE' &&
                  item.user.plan.internalName.indexOf('CSTM_TIER_')
                "
                :color="item.user.plan.color"
                class="ma-1"
                text-color="white"
              >
                <v-icon> {{ item.user.plan.icon }}</v-icon
                >&nbsp;
                {{ item.user.plan.name }}
              </v-chip>
              <v-chip
                v-if="item.user.beta"
                class="ma-1"
                color="deep-purple"
                text-color="white"
              >
                β Beta
              </v-chip>
            </div>
          </v-tooltip>
        </template>

        <template v-slot:item.activeUsersCount="{ item }">
          {{ item.activeUsersCount }}
        </template>

        <template v-slot:item.options="{ item }">
          <v-card-actions>
            <v-btn
              class="rounded-xl"
              v-if="item.domain"
              :loading="loading"
              @click="setDefault(item)"
            >
              Set Default
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)

export default {
  name: "Domains",
  data() {
    return {
      loading: false,
      donated: {
        pager: [],
        page: 1,
        domains: [],
        search: "",
        headers: [
          { text: "Domain", value: "domain" },
          { text: "Active", value: "active" },
          { text: "Active Users", value: "activeUsersCount" },
          { text: "Options", value: "options" }
        ]
      },
      all: {
        pager: [],
        page: 1,
        domains: [],
        search: "",
        headers: [
          { text: "Domain", value: "domain" },
          { text: "Contributed by", value: "user.username" },
          { text: "Active Users", value: "activeUsersCount" },
          { text: "Options", value: "options" }
        ]
      },
      deleteDomain: {
        modal: false,
        item: [],
        loading: false
      },
      defaultDomain: {
        modal: false,
        subdomain: "",
        subdomains: [],
        item: [],
        subdomainEnabled: false,
        loading: false
      }
    }
  },
  methods: {
    calculateColor(user) {
      if (this.$vuetify.theme.dark) {
        return "#ffffff"
      } else {
        return "#000000"
      }
    },
    doDeleteDomain() {
      this.deleteDomain.loading = true
      this.axios
        .put("/api/v1/domains/simple/zone/delete", {
          domain: this.deleteDomain.item.domain
        })
        .then(() => {
          this.deleteDomain.loading = false
          this.getDomains(true, true)
          this.deleteDomain.modal = false
          this.deleteDomain.item = []
        })
        .catch((e) => {
          this.deleteDomain.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    startDeleteDomain(item) {
      this.deleteDomain.item = item
      this.deleteDomain.modal = true
    },
    dayjs(params) {
      return dayjs(params)
    },
    recheckNS(item) {
      this.loading = true
      this.axios
        .get("/api/v1/domains/simple/zone/get/" + item.domain)
        .then(() => {
          this.loading = false
          this.getDomains(true, true)
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    setDefault(item) {
      this.defaultDomain.item = item
      this.axios
        .get("/api/v1/domains/simple/record/get/" + item.domain)
        .then((res) => {
          this.loading = false
          this.defaultDomain.subdomains = res.data
          this.defaultDomain.modal = true
        })
        .catch((e) => {
          this.defaultDomain.modal = true
          AjaxErrorHandler(this.$store)(e)
        })
    },
    setDefaultAction() {
      this.defaultDomain.loading = true
      this.axios
        .put("/api/v1/domains/default/" + this.defaultDomain.item.id, {
          subdomain: this.defaultDomain.subdomainEnabled,
          subdomainName: this.defaultDomain.subdomain
        })
        .then(() => {
          this.defaultDomain.loading = false
          this.defaultDomain.modal = false
        })
        .catch((e) => {
          this.defaultDomain.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    setDefaultSubdomainAction(item) {
      this.loading = true
      this.axios
        .put("/api/v1/domains/subdomains/default/" + item.id)
        .then(() => {
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getDomains(init, donated) {
      if (!donated) {
        this.axios
          .get("/api/v1/domains/all/" + this.all.page)
          .then((res) => {
            if (init) {
              this.all.domains = res.data
            } else {
              this.all.domains.push(res.data)
            }
          })
          .catch((e) => {
            AjaxErrorHandler(this.$store)(e)
          })
      } else {
        this.loading = true
        this.axios
          .get("/api/v1/domains/donated/" + this.donated.page)
          .then((res) => {
            if (init) {
              this.donated.domains = res.data
            } else {
              this.donated.domains.push(res.data)
            }
            this.loading = false
          })
          .catch((e) => {
            this.loading = false
            AjaxErrorHandler(this.$store)(e)
          })
      }
    }
  },
  mounted() {
    this.getDomains(true, false)
    this.getDomains(true, true)
  },
  watch: {
    "donated.page": function () {
      this.getDomains(true, true)
    },
    "all.page": function () {
      this.getDomains(true, false)
    }
  }
}
</script>

<style scoped></style>
